import {
    CharacterWrapper,
    CharacterImg,
} from './style';

export default (props) => {
    const { characterImg } = props;
    return (
        <CharacterWrapper>
            <CharacterImg src={characterImg} />
        </CharacterWrapper>
    );
}